import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Deliverables from '../components/Deliverables';

function mapStateToProps(state) {
  return {
    actualContext: state.steps.context,
    app: state.app,
  };
}

function mapDispatchToProps() {
  return {};
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Deliverables));



// WEBPACK FOOTER //
// ./src/components/Steps/Deliverables/container/index.js